<template>
<div class="perfect-info">
  <div class="step-module">
    <div
      class="step-item"
      v-for="(item,index) in stepList"
      :key="index"
    >
      <span
        class="text"
        :class="{
          'theme-color': item.value == step,
        }"
      >{{item.label}}</span>
      <i class="el-icon-arrow-right icon-el-right"></i>
    </div>
  </div>
  <div class="info-content">
    <personal-info
      ref="personal"
      :all-data="allData"
      :nationality-list="countryList"
      :sex-list="sexList"
      v-show="step == 1"
      @next-step="nextStepHandle"
    ></personal-info>
    <id-validate
      ref="id"
      v-show="step == 2"
      :all-data="allData"
      :card-type-list="cardTypeList"
      @prev-step="prevStepHandle"
      @next-step="nextStepHandle"
    ></id-validate>
    <address-validate
      ref="address"
      v-show="step == 3"
      :all-data="allData"
      :nationality-list="countryList"
      @prev-step="prevStepHandle"
      @next-step="nextStepHandle"
    ></address-validate>
    <investment-experience
      ref="investment"
      v-show="step == 4"
      :all-data="allData"
      @prev-step="prevStepHandle"
      @next-step="nextStepHandle"
    ></investment-experience>
    <statement-content
      v-show="step == 5"
      @prev-step="prevStepHandle"
      @submit="submitHandle"
    ></statement-content>
  </div>
</div>
</template>

<script>
import { setLocalStorage } from '@/utils/common';
import { OpenApply } from "@/api/user";
import { GetCustInFo } from '@/api/userCenter.js';
import { mapGetters } from 'vuex'
import { getDictListByType } from '@/api/home.js';
import personalInfo from "@/components/perfectInfo/personalInfo";
import idValidate from "@/components/perfectInfo/idValidate";
import addressValidate from "@/components/perfectInfo/addressValidate";
import investmentExperience from "@/components/perfectInfo/investmentExperience";
import statementContent from "@/components/perfectInfo/statementContent";
export default {
  name: "index",
  components: {
    personalInfo,
    idValidate,
    addressValidate,
    investmentExperience,
    statementContent,
  },
  data() {
    let _this = this;
    return {
      step: 1,
      stepList: [
        { stepName: 'personal',label: _this.$t('User.userInfo'),value: 1 },
        { stepName: 'idValidate',label: _this.$t('User.authentication'),value: 2 },
        { stepName: 'addressValidate',label: _this.$t('User.addressVerifi'),value: 3 },
        { stepName: 'investmentExperience',label: _this.$t('User.investExp'),value: 4 },
        { stepName: 'statement',label: _this.$t('Register.declare'),value: 5 },
      ],
      countryList: [],// 国家列表
      sexList: [],// 性别
      cardTypeList: [],// 证件类型
      allData: {}
    }
  },
  created(){
    this.getDictListByType('countryList');
    this.getDictListByType('sexList');
    this.getDictListByType('certTypes');
    this.getCustomerData();
  },
  computed: {
    ...mapGetters(['language','userInfo']),
  },
  methods: {
    getCustomerData(){
      let parmas = {
        custId: this.userInfo.id
      };
      GetCustInFo(parmas).then((res) => {
        this.allData = res.data;
        switch (this.allData.profileProgress){
          case 0:
          case 1:
            this.step = 1;
            break;
          case 2:
          case 3:
          case 4:
          case 5:
            this.step = this.allData.profileProgress;
        }
        if(this.allData.auditStatus == 3){
          // 审核拒绝,第一步开始
          this.step = 1;
        }
      });
    },
    nextStepHandle(){
      // 也是需要提交 todo
      this.step = this.step + 1;
    },
    prevStepHandle(){
      if(this.step == 1) return;
      this.step = this.step - 1;
    },
    getDictListByType(type){
      let parmas = {
        type: type
      };
      getDictListByType(parmas).then((res) => {
        if(res.data.length){
          if (res.data[0].type == 'countryList') {
            this.countryList = res.data;
          } else if (res.data[0].type == 'sexList') {
            this.sexList = res.data;
          }else if (res.data[0].type == 'certTypes') {
            this.cardTypeList = res.data;
          }
        }
      });
    },

    submitHandle(){
      // todo
      let parmas = {
        id: this.userInfo.id,
        ...this.$refs.personal.getParams(),
        ...this.$refs.id.getParams(),
        ...this.$refs.address.getParams(),
        ...this.$refs.investment.getParams(),
      };
      if(!parmas.certValidatedImgBack){
        parmas.certValidatedImgBack = '';
      }

      OpenApply(parmas).then((res) => {
        if (res.status == 10000) {

          //更新localStarage和vuex的userInfo数据
          let selfUserInfo = JSON.parse(localStorage.getItem('userInfo'));
          selfUserInfo.auditStatus = res.data.auditStatus;
          selfUserInfo.custStatus = res.data.custStatus;
          let selfVuexUserInfo = JSON.parse(JSON.stringify(this.userInfo));
          selfVuexUserInfo.auditStatus = res.data.auditStatus;
          selfVuexUserInfo.custStatus = res.data.custStatus;
          localStorage.setItem('userInfo',JSON.stringify(selfUserInfo));
          this.$store.commit('setUserInfo', selfVuexUserInfo);

          setLocalStorage('custStatus', res.data.custStatus);
          this.$message({
            type: 'success',
            message: this.$t('Submission_for_review_successful')
          });

          this.$router.push({name: 'dashboard'});
        }
      }).catch((error) => {

      });
    }
  },
}
</script>

<style lang="scss" scoped>
.perfect-info {
  .step-module {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    .step-item {
      color: #B9B9C3;
      font-size: 14px;
      margin-bottom: 24px;
      .icon-el-right {
        margin: 0 10px;
      }
      &:last-child {
        .icon-el-right {
          display: none;
        }
      }
    }
  }

}
</style>
<style lang="scss">
.perfect-info {
  .card {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 10px 20px;
    margin-bottom: 24px;
    .title {
      font-size: 16px;
      margin-bottom: 20px;
      font-weight: bold;
    }
    .h5-el {
      margin-bottom: 10px;
    }
  }
  .avatar-uploader {

    text-align: left;
    .idimg {
      width: 200px;
      height: 120px;
      box-sizing: border-box;
      border: 2px dashed #D8D6DE;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #B9B9C3;
      .el-icon-plus {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .next-btn {
    margin-right: 10px;
  }
  // 身份照片和地址照片正确示范和错误示范
  @media screen and (min-width: 768px){
    .demo-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }


  @media screen and (max-width: 768px){
    .demo-box {
      .img-out {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
